export default function notebookActivities() {
  return [
    {
      meta: {
        format: "JSON",
        version: "1.1.0",
        projectId: "pruebareact-37ac8",
        resourcePath: ["Activities"],
        recursive: false,
        creationTime: 1665583291,
        app: "firefoo",
      },
      data: {
        "05pFHMNdhfo6Zg99oq5c": {
          activityName:
            "Culture of E. Coli DH5α and preparation of serial dilutions",
          area: "Safety",
          bookPage: "14",
          date: "2022-06-30",
          description: "",
          __collections__: {},
        },
        "06PGnrCUaW67JZEgLqUX": {
          activityName: "Continuation of Lysis",
          area: "Degradation",
          bookPage: "26",
          date: "2022-07-13",
          description: "",
          __collections__: {},
        },
        "0GYQzEEPopkf9jkFq2jI": {
          activityName: "Preparation of acetate buffer 0.1 M pH 5",
          area: "Degradation",
          bookPage: "31",
          date: "2022-07-19",
          description: "",
          __collections__: {},
        },
        "0mIUnG3o0pf1Ha3aRb8o": {
          activityName: "Plasmid extraction",
          area: "Biosensor",
          bookPage: "98",
          date: "2022-09-27",
          description: "",
          __collections__: {},
        },
        "0qcLC30twVUotcMjuUok": {
          activityName:
            "Culturing of the transformed cells backup, from the 10th of July",
          area: "Safety",
          bookPage: "24",
          date: "2022-07-21",
          description: "",
          __collections__: {},
        },
        "0uCf8xddk6XaXAEQpGwQ": {
          activityName: "Preparation of solubility laccases samples",
          area: "Degradation",
          bookPage: "14",
          date: "2022-07-05",
          description: "",
          __collections__: {},
        },
        "11KMELUlFYDvVmMkx813": {
          activityName: "Calculations of gel purification",
          area: "Biosensor",
          bookPage: "101",
          date: "2022-10-03",
          description: "",
          __collections__: {},
        },
        "1NNW1lkjc68nBpJLo7rL": {
          activityName: "Preparation of acetate buffer 0.1 M pH 5",
          area: "Degradation",
          bookPage: "13",
          date: "2022-07-04",
          description: "",
          __collections__: {},
        },
        "1f9caxdfvF1shrIDdCtc": {
          activityName: "E. Coli DH5a Transformation",
          area: "Safety",
          bookPage: 0,
          date: "2022-03-21",
          description: "With Laccases and ESR1",
          __collections__: {},
        },
        "1yVQpJFhy2TpP9eJaKzs": {
          activityName:
            "Functionality assay with guaiacol for immobilized laccase (2nd time)",
          area: "Degradation",
          bookPage: "51",
          date: "2022-09-10",
          description: "",
          __collections__: {},
        },
        "267LAJfPDhki8tNkL5mA": {
          activityName: "Making of the immobilization plan",
          area: "Degradation",
          bookPage: "15",
          date: "2022-07-06",
          description: "",
          __collections__: {},
        },
        "26ghVW1yqfqzeX1HsNbh": {
          activityName: "Ligation with the pJET1.2 blunt vector",
          area: "Biosensor",
          bookPage: "92",
          date: "2022-09-07",
          description: "",
          __collections__: {},
        },
        "2CIUtaAtlCeRhYbcZZ71": {
          activityName:
            "Ligation of gBlock on pJET 1.2 vector and synthesized ESR1 construct and Laccase construct",
          area: "Biosensor",
          bookPage: "70",
          date: "2022-07-18",
          description: "",
          __collections__: {},
        },
        "2HnIT2ETodM6EAU4HfDU": {
          activityName: "Construction of carbamazepine calibration curve. ",
          area: "Degradation",
          bookPage: "40",
          date: "2022-08-24",
          description: "",
          __collections__: {},
        },
        "2Qm9OWNlgRJyMCV5cAaG": {
          activityName: "Measurement of immobilized laccase",
          area: "Degradation",
          bookPage: "31",
          date: "2022-07-19",
          description: "",
          __collections__: {},
        },
        "2VdDl6YSfjyt2ZFUc3kW": {
          activityName: "Protein precipitation",
          area: "Biosensor",
          bookPage: "69",
          date: "2022-01-26",
          description: "",
          __collections__: {},
        },
        "2ZyAz1lePSwclrbwsHhO": {
          activityName: "Making backups of the backups",
          area: "Safety",
          bookPage: "33",
          date: "2022-08-15",
          description: "",
          __collections__: {},
        },
        "2vAioLY9dLItFwfDbDDg": {
          activityName:
            "Guaiacol assay with commercial laccase and zeolite in order to evaluate possible degradation of the guaiacol by zeolite.",
          area: "Degradation",
          bookPage: "53",
          date: "2022-09-23",
          description: "",
          __collections__: {},
        },
        "3EA7mjSOekJfiQQHg94Q": {
          activityName: " gBlock dilutions",
          area: "Biosensor",
          bookPage: "89",
          date: "2022-09-05",
          description: "",
          __collections__: {},
        },
        "3MckJJ1hd6KjgOE5JlKl": {
          activityName: "Electrophoresis gel",
          area: "Biosensor",
          bookPage: "76",
          date: "2022-07-21",
          description: "",
          __collections__: {},
        },
        "3N52Ra2STmlIVPuMNByX": {
          activityName: "Electrophoresis",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-02-24",
          description: "Checking the PCR",
          __collections__: {},
        },
        "3RDavNvi4oMvPjQohYIG": {
          activityName: "Chemically Competent BL21 Control Preparation ",
          area: "Biosensor",
          bookPage: "93",
          date: "2022-09-13",
          description: "",
          __collections__: {},
        },
        "3Zcqs81NVWQtlgwYZZWK": {
          activityName: "Restriction map",
          area: "Biosensor",
          bookPage: "97",
          date: "2022-09-21",
          description: "",
          __collections__: {},
        },
        "3mN8Kkig7PDmjJ2XZfqg": {
          activityName: "Preparation of Laccase in citrates buffer 1 mg/mL",
          area: "Degradation",
          bookPage: "37",
          date: "2022-08-15",
          description: "",
          __collections__: {},
        },
        "3o0UIm7zbV15tGCSfBON": {
          activityName: "Digestion of LacTV and ESR1",
          area: "Biosensor",
          bookPage: "100",
          date: "2022-09-30",
          description: "",
          __collections__: {},
        },
        "4MBYLtNQXD3WRig8ZiaY": {
          activityName: "Preparation of Blank solutions",
          area: "Degradation",
          bookPage: "33",
          date: "2022-07-21",
          description: "",
          __collections__: {},
        },
        "4YVLU7myl68HW1QIotRx": {
          activityName: "Gold nanoparticles Self-Assembly on QCMs",
          area: "Biosensor",
          bookPage: "65",
          date: "2022-10-10",
          description: "",
          __collections__: {},
        },
        "53iWw2dtaQG2U4XyW5JE": {
          activityName: "Recap of samples of green malachite",
          area: "Degradation",
          bookPage: "48",
          date: "2022-09-05",
          description: "",
          __collections__: {},
        },
        "5CJGu9WdMeo5ReKpVxPk": {
          activityName: "Aliquot cell preparations",
          area: "Safety",
          bookPage: "34",
          date: "2022-08-18",
          description: "",
          __collections__: {},
        },
        "5JqN9NZtXi0CIiEGKTX4": {
          activityName:
            "Functionality assay with laccase guayacol of purified T.V.",
          area: "Degradation",
          bookPage: "54",
          date: "2022-09-23",
          description: "",
          __collections__: {},
        },
        "5Tq2iy7nFloIOgufI6NP": {
          activityName: "Digestions of pet 17b, Pp 5 and Nc 2",
          area: "Safety",
          bookPage: "44",
          date: "2022-09-27",
          description: "",
          __collections__: {},
        },
        "624uudT0azs07yNjgEXZ": {
          activityName:
            "Preparation of solutions for Bisphenol A degradation by laccase",
          area: "Degradation",
          bookPage: "33",
          date: "2022-07-21",
          description: "",
          __collections__: {},
        },
        "639a07XVrHyLZQ1Ce4Lf": {
          activityName: "RecA1 and RecA2 plasmid extraction",
          area: "Biosensor",
          bookPage: "95",
          date: "2022-09-20",
          description: "",
          __collections__: {},
        },
        "65RDDRrf762vIWSJl8o9": {
          activityName: "Gold nanoparticles incubation with protein",
          area: "Biosensor",
          bookPage: "64",
          date: "2022-10-08",
          description: "",
          __collections__: {},
        },
        "69sQNJCOc7sOhBUu1cPM": {
          activityName:
            "Transformation of E. coli BL21 with 13I, 13M, 15A and 15E ",
          area: "Degradation",
          bookPage: "2",
          date: "2022-05-23",
          description: "",
          __collections__: {},
        },
        "6UastDnqz8jrg4oiHRvi": {
          activityName: "BPA degradation by Laccase",
          area: "Degradation",
          bookPage: "34",
          date: "2022-07-25",
          description: "",
          __collections__: {},
        },
        "73moM66H8p3TOUiYMqfU": {
          activityName: "F-N iGEM primer preparation ",
          area: "Biosensor",
          bookPage: "70",
          date: "2022-05-31",
          description: "",
          __collections__: {},
        },
        "7OxQf6t29SBplWdVtl3Y": {
          activityName: "Digestions of the plasmid samples",
          area: "Safety",
          bookPage: "27",
          date: "2022-07-27",
          description: "",
          __collections__: {},
        },
        "7RMQAsxiCQ0mS4eh4wGA": {
          activityName: "Gel of electrophoresis",
          area: "Safety",
          bookPage: "27",
          date: "2022-07-26",
          description: "",
          __collections__: {},
        },
        "7vaLh6qO7wh4v50qYXqU": {
          activityName: "Preparation of 100 mL HCl 1 M",
          area: "Degradation",
          bookPage: "48",
          date: "2022-09-06",
          description: "",
          __collections__: {},
        },
        "8QatICsgCcqHkWWHGobf": {
          activityName: "Absorbance measurement of Nc1, N2 and BL21",
          area: "Safety",
          bookPage: "39",
          date: "2022-09-09",
          description: "",
          __collections__: {},
        },
        "8XN3QJub2550QgA8jx2o": {
          activityName: "SEM characterization of gold nanoparticles 0.125% (2)",
          area: "Biosensor",
          bookPage: "63",
          date: "2022-09-29",
          description: "",
          __collections__: {},
        },
        "8XmizV4tgsbplXSajR2p": {
          activityName: "LMWC (Low Molecular Weight Chitosan) Solution",
          area: "Biosensor",
          bookPage: "61",
          date: "2022-09-19",
          description: "",
          __collections__: {},
        },
        "8nnpiA05sYgn0rRPxudi": {
          activityName: "Experimental preparation",
          area: "Degradation",
          bookPage: "38",
          date: "2022-08-15",
          description: "",
          __collections__: {},
        },
        "8syTLPBgn5VZuC2G8bnQ": {
          activityName: "Preparation of medium for the treatment A",
          area: "Safety",
          bookPage: "20",
          date: "2022-07-11",
          description: "",
          __collections__: {},
        },
        "8yVij2lAjQOKMNCFEgag": {
          activityName:
            "UV-VIS analysis of supernatant of the Laccase immobilization",
          area: "Degradation",
          bookPage: "33",
          date: "2022-07-21",
          description: "",
          __collections__: {},
        },
        "95UaEK1WbhP9xqll5kqE": {
          activityName: "Electrophoresis of the ligation",
          area: "Biosensor",
          bookPage: "102",
          date: "2022-10-04",
          description: "",
          __collections__: {},
        },
        "9DBJsmEbkLj9Ar89iv6H": {
          activityName:
            " Dissolution of 7.5 mL, 3 mL and 12.5 mL of LMWC-AuNPs ",
          area: "Biosensor",
          bookPage: "61",
          date: "2022-09-21",
          description: "",
          __collections__: {},
        },
        "9MrXflSMoHaCrkXKjMsU": {
          activityName:
            "Continuation of the immobilization of laccase with zeolite. ",
          area: "Degradation",
          bookPage: "23",
          date: "2022-07-11",
          description: "",
          __collections__: {},
        },
        "9arEkP9XhdtybbyE2uyV": {
          activityName: "BPA measured absorbances from degradation assay",
          area: "Degradation",
          bookPage: "59",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        "9rUS7WPeUXkFcQs2fht3": {
          activityName: "Electrophoresis",
          area: "Biosensor",
          bookPage: "81",
          date: "2022-08-10",
          description: "",
          __collections__: {},
        },
        "9zFZiOhUmMDrwHmQS0Iz": {
          activityName: "Verification of ESR1 plasmid  ",
          area: "Degradation",
          bookPage: "70",
          date: "2022-07-02",
          description: "",
          __collections__: {},
        },
        A8djQ8dW2aMW91JECHbg: {
          activityName: "Culture Medium Concentration",
          area: "Degradation",
          bookPage: "22",
          date: "2022-07-08",
          description: "",
          __collections__: {},
        },
        AdCa2hlesXSjBQ9wXQfi: {
          activityName:
            "Construction of calibration curve (standard) of BSA + BPA and BPA + Laccase.",
          area: "Degradation",
          bookPage: "17",
          date: "2022-07-07",
          description: "",
          __collections__: {},
        },
        AhH2Vn5AnBOPYj7UlflZ: {
          activityName: "Protein purification and solubility tests",
          area: "Biosensor",
          bookPage: "83",
          date: "2022-08-23",
          description: "",
          __collections__: {},
        },
        Ak0smQhZqnKpydRUxghu: {
          activityName: "SDS-PAGE gel elaboration",
          area: "Degradation",
          bookPage: "2",
          date: "2022-05-24",
          description: "",
          __collections__: {},
        },
        B6y7knbOg2CaIrYWah7F: {
          activityName: "SDS-PAGE",
          area: "Safety",
          bookPage: "37",
          date: "2022-09-06",
          description: "",
          __collections__: {},
        },
        BHdP8kdxYmhOWtEGhRd9: {
          activityName: "Plates grown",
          area: "Biosensor",
          bookPage: "74",
          date: "2022-07-20",
          description: "",
          __collections__: {},
        },
        Bb31lR7VeZ81tH7wnP81: {
          activityName: "Absorbance of the assay",
          area: "Degradation",
          bookPage: "51",
          date: "2022-09-08",
          description: "",
          __collections__: {},
        },
        BkCZuugoEG7Jj6EPpzep: {
          activityName:
            "Plate results (treatments A, B and C), spatulated the 6th and 7th of July.",
          area: "Safety",
          bookPage: "20",
          date: "2022-07-08",
          description: "",
          __collections__: {},
        },
        CGBMQw7tmnH5jXJhRJks: {
          activityName: "Protein assemble to nanoparticles characterization.",
          area: "Biosensor",
          bookPage: "66",
          date: "2022-10-11",
          description: "",
          __collections__: {},
        },
        COIjHz5BALaqR9HOeHTx: {
          activityName:
            "Soluble Protein Interaction for Nickel Resin Capture (IMAC)",
          area: "Degradation",
          bookPage: "22",
          date: "2022-07-08",
          description: "",
          __collections__: {},
        },
        CPKcUqtUfuKTCATsPDHy: {
          activityName: "Solubility test ESR1 + LacTV (expression)",
          area: "Biosensor",
          bookPage: "104",
          date: "2022-10-06",
          description: "",
          __collections__: {},
        },
        DV935S3b9tvGToT8dyrW: {
          activityName:
            "Spectrophotometric analysis of the immobilization washes. ",
          area: "Degradation",
          bookPage: "24",
          date: "2022-07-12",
          description: "",
          __collections__: {},
        },
        DfJcUABEl9rToAce8jhA: {
          activityName: "Ex vitro seeds germination",
          area: "Degradation",
          bookPage: "9",
          date: "2022-06-23",
          description: "",
          __collections__: {},
        },
        DiqQqLfCD6kMg7yjpQQc: {
          activityName: "SDS-PAGE gel running",
          area: "Degradation",
          bookPage: "28",
          date: "2022-07-14",
          description: "",
          __collections__: {},
        },
        EUaDgd5i849ZCzwG4bcv: {
          activityName:
            "UV-Vis characterization of gold nanoparticles 0.25% (2)",
          area: "Biosensor",
          bookPage: "63",
          date: "2022-10-06",
          description: "",
          __collections__: {},
        },
        EWAQNTkoFKhGYX64Dw0d: {
          activityName: "Laccase expression and solubility assay inoculation",
          area: "Degradation",
          bookPage: "2",
          date: "2022-05-25",
          description: "",
          __collections__: {},
        },
        FCyJzw4p3eOGDXAU5SmP: {
          activityName: "Preparation of Imidazole solutions",
          area: "Degradation",
          bookPage: "32",
          date: "2022-07-19",
          description: "",
          __collections__: {},
        },
        FLToYqwTKoOm3x0PxLxX: {
          activityName: "SDS-PAGE Gels",
          area: "Degradation",
          bookPage: "11",
          date: "2022-06-30",
          description: "",
          __collections__: {},
        },
        FS6UYcoUo9Z7PAOwXqE3: {
          activityName:
            "Preparation of different solutions for a guaiacol scan",
          area: "Degradation",
          bookPage: "39",
          date: "2022-08-16",
          description: "",
          __collections__: {},
        },
        Fqr3uE36pXfzcryh4cS8: {
          activityName: "Digestion of pET17b with ECORI-HF ",
          area: "Biosensor",
          bookPage: "103",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        G0hmb66mOvV4PL9ooqgx: {
          activityName: "Nanoparticle synthesis (2)",
          area: "Biosensor",
          bookPage: "62",
          date: "2022-09-23",
          description: "",
          __collections__: {},
        },
        GId9SjjAieAVFYhscnOE: {
          activityName: "PCR with Master Mix x2 (green)",
          area: "Biosensor",
          bookPage: "79",
          date: "2022-07-27",
          description: "",
          __collections__: {},
        },
        GS3Z1H6oQF3lYJPiO6GY: {
          activityName:
            "Functionality assays with guaiacol as a substrate for purified laccases. ",
          area: "Degradation",
          bookPage: "43",
          date: "2022-08-25",
          description: "",
          __collections__: {},
        },
        Giyzu0w9292EH6BMKpj9: {
          activityName:
            "Competent cells transformation, only BL21-DE3 and DH5ɑ",
          area: "Safety",
          bookPage: "24",
          date: "2022-07-20",
          description: "",
          __collections__: {},
        },
        GwVjeLOREoSQBToMh8Y2: {
          activityName: "ESR1 “21” culture",
          area: "Biosensor",
          bookPage: "67",
          date: "2022-01-24",
          description: "",
          __collections__: {},
        },
        HDaXZTALs3HNdN6WziS1: {
          activityName:
            "Transformation of E. coli BL21 with 13I, 13M, 15A and 15E ",
          area: "Degradation",
          bookPage: "2",
          date: "2022-05-23",
          description: "",
          __collections__: {},
        },
        HKtfkJP053Idog98fPSY: {
          activityName: "Preparation of BPA-Lac-Buffer",
          area: "Degradation",
          bookPage: "60",
          date: "2022-10-08",
          description: "",
          __collections__: {},
        },
        HM37c8WaqAuZDCyb3S7T: {
          activityName: "Transformed DH5α with RecA intein plasmid inoculation",
          area: "Biosensor",
          bookPage: "92",
          date: "2022-09-12",
          description: "",
          __collections__: {},
        },
        HZFQgvzRQNJOhVeId9w1: {
          activityName:
            "Use of inteins. Plan 3: pET 17b digested with ECORI HF and blunting enzyme to ligate with inteins by PCR",
          area: "Biosensor",
          bookPage: "102",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        HsFRfE60osJUMrnkngKL: {
          activityName: "RecA intein plasmid transformation in DH5α",
          area: "Biosensor",
          bookPage: "92",
          date: "2022-09-10",
          description: "",
          __collections__: {},
        },
        Hth7OVso6p9NgWg4HTYA: {
          activityName: "Inoculation of ESRI4 and Lac8 for plasmid extraction",
          area: "Biosensor",
          bookPage: "98",
          date: "2022-09-26",
          description: "",
          __collections__: {},
        },
        HyllQGNtoZ6jURNAsRAu: {
          activityName: "Ligation of ESR1_HD and LACTV_HD in pET17b",
          area: "Biosensor",
          bookPage: "101",
          date: "2022-10-03",
          description: "",
          __collections__: {},
        },
        I4ybl22Uj8j2nRxCANxr: {
          activityName: "Culture medium preparation of DH5α cells",
          area: "Safety",
          bookPage: "3",
          date: "2022-05-23",
          description: "",
          __collections__: {},
        },
        JCR3vPbFMbANyCvhSBpC: {
          activityName: "Laccase transformation",
          area: "Degradation",
          bookPage: "10",
          date: "2022-06-27",
          description: "",
          __collections__: {},
        },
        JE56F3nL342fGslbYeUy: {
          activityName: "Absorbance measurements",
          area: "Safety",
          bookPage: "40",
          date: "2022-09-10",
          description: "",
          __collections__: {},
        },
        JMkpwGD185ZTFLFRrJHl: {
          activityName:
            "Functionality assay with guaiacol for immobilized laccase",
          area: "Degradation",
          bookPage: "49",
          date: "2022-09-07",
          description: "",
          __collections__: {},
        },
        Jc4ODs8FQWImqMS06yH0: {
          activityName: "Drying of zeolite solution in desiccator.",
          area: "Degradation",
          bookPage: "45",
          date: "2022-08-29",
          description: "",
          __collections__: {},
        },
        JcJi9xasmCSHi7JupwE1: {
          activityName: "AFM characterization of gold nanoparticles 0.25% (2)",
          area: "Biosensor",
          bookPage: "63",
          date: "2022-09-29",
          description: "",
          __collections__: {},
        },
        Jhy8LdUDYUtr4WxhZykW: {
          activityName: "Preparation of 2 mL aliquots of injectable water",
          area: "Biosensor",
          bookPage: "74",
          date: "2022-07-19",
          description: "",
          __collections__: {},
        },
        KDCEMyzkZcstc3iShXZy: {
          activityName: "Plasmid extraction",
          area: "Biosensor",
          bookPage: "79",
          date: "2022-07-28",
          description: "",
          __collections__: {},
        },
        KEs0wh61bnbZAlmbAlj8: {
          activityName: "PCR",
          area: "Degradation",
          bookPage: 0,
          date: "2022-03-02",
          description: "With changes in temperature (gradients from 55-57 °C)",
          __collections__: {},
        },
        KL3ixIQbcIrE8h3WLySD: {
          activityName: "Use of inteins. Plan 4: Her2 and GEPR in Zeta Sizer",
          area: "Biosensor",
          bookPage: "103",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        KRqCEE8iD0p17c6GVPsJ: {
          activityName: "New PCR",
          area: "Safety",
          bookPage: "31",
          date: "2022-08-11",
          description: "",
          __collections__: {},
        },
        KUG2L1GkM2UNcKBZZLhx: {
          activityName: "Preparation of 300 mL citrates buffer 0.1 M pH 5.0",
          area: "Degradation",
          bookPage: "56",
          date: "2022-10-03",
          description: "",
          __collections__: {},
        },
        KZ8yLB73FjnNgUSKLMbu: {
          activityName: "Culturing of plates with 4.5 mM of isoeugenol",
          area: "Safety",
          bookPage: "25",
          date: "2022-07-25",
          description: "",
          __collections__: {},
        },
        LDEiPxP8imTOWjkdO7gN: {
          activityName: "Preparation of BPA and Laccase solutions",
          area: "Degradation",
          bookPage: "57",
          date: "2022-10-04",
          description: "",
          __collections__: {},
        },
        LHoPPWGp66zSA8t6Wjta: {
          activityName: "PCR with synthetic primers",
          area: "Biosensor",
          bookPage: "82",
          date: "2022-08-15",
          description: "",
          __collections__: {},
        },
        Lc6DCWuddpIpE7jNSvss: {
          activityName: "Counting of DH5ɑ colonies",
          area: "Safety",
          bookPage: "48",
          date: "2022-10-06",
          description: "",
          __collections__: {},
        },
        LzeklMXVLE5UfxeTTM2E: {
          activityName:
            "Sterility Test verification and emulsification with Tween80",
          area: "Safety",
          bookPage: "11",
          date: "2022-06-27",
          description: "",
          __collections__: {},
        },
        M2OnpFxxn7ZdqCiJrD64: {
          activityName: "Electrophoresis gel  R2A",
          area: "Biosensor",
          bookPage: "67",
          date: "2022-05-24",
          description: "",
          __collections__: {},
        },
        MC3GMbpRZvozYWSET4zS: {
          activityName: "Amplification by PCR",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-03-28",
          description: "For laccases and ESR1",
          __collections__: {},
        },
        MDguRIhMXv4tiQcRTOfW: {
          activityName: "GBlock synthesis ",
          area: "Biosensor",
          bookPage: "67",
          date: "2022-05-16",
          description: "",
          __collections__: {},
        },
        MS3WHdstVLnLs1qXYbFw: {
          activityName: "Evaluation of the inhibitory effect of isoeugenol",
          area: "Safety",
          bookPage: "35",
          date: "2022-08-22",
          description: "",
          __collections__: {},
        },
        Mc4XJWfa2yFUxYcaVuzI: {
          activityName: "Digestions R2A",
          area: "Biosensor",
          bookPage: "67",
          date: "2022-05-24",
          description: "",
          __collections__: {},
        },
        Mm9H5sncy9kxrCyCK3bw: {
          activityName:
            "Laccase expression and solubility assay SDS-PAGE analysis",
          area: "Degradation",
          bookPage: "6",
          date: "2022-06-20",
          description: "",
          __collections__: {},
        },
        NXsLOaRYSkQ5pBqRJuVH: {
          activityName: "ISE laccase purification",
          area: "Degradation",
          bookPage: "26",
          date: "2022-07-13",
          description: "",
          __collections__: {},
        },
        NbXdAEhkyyFUANX7fhMm: {
          activityName:
            "Cells counting of the serial dilutions of DH5ɑ and BL21",
          area: "Safety",
          bookPage: "43",
          date: "2022-09-23",
          description: "",
          __collections__: {},
        },
        NoBikondyfiqrLonlJyT: {
          activityName: "Results immobilization assay (Sep 6)",
          area: "Degradation",
          bookPage: "50",
          date: "2022-09-08",
          description: "",
          __collections__: {},
        },
        NuyDTbIUFWV83sXnrOIL: {
          activityName:
            "SDS-PAGE for periplasmic protein expression in ESR1 and LacTV",
          area: "Biosensor",
          bookPage: "93",
          date: "2022-09-14",
          description: "",
          __collections__: {},
        },
        OF4ocuainsEJf6JWCioC: {
          activityName: "Absorbance laccase readings",
          area: "Biosensor",
          bookPage: "96",
          date: "2022-09-21",
          description: "",
          __collections__: {},
        },
        OVvoHUCMoyMfAxEV7MLA: {
          activityName:
            "RecA intein ligation in pJET 1.2/blunt and HMS174 transformation",
          area: "Biosensor",
          bookPage: "94",
          date: "2022-09-15",
          description: "",
          __collections__: {},
        },
        OWtn4UIbNgFpD0mF2AEO: {
          activityName: "Laccase expression and solubility assay",
          area: "Degradation",
          bookPage: "2",
          date: "2022-05-26",
          description: "",
          __collections__: {},
        },
        OqE0jF715porDLJDunly: {
          activityName:
            "Transformation of Lac15A and Lac 15E in HMS174 and BL21Solub",
          area: "Biosensor",
          bookPage: "100",
          date: "2022-09-29",
          description: "",
          __collections__: {},
        },
        P4ST1Vc3LLpWI33X6vsd: {
          activityName: "Acetates buffer preparation",
          area: "Degradation",
          bookPage: "38",
          date: "2022-08-15",
          description: "",
          __collections__: {},
        },
        P8yQwH7HNkJBM9ASNqFt: {
          activityName: "Tubes with LB liquid medium ",
          area: "Safety",
          bookPage: "9",
          date: "2022-06-15",
          description: "",
          __collections__: {},
        },
        PCuJLaWC4nWaSBhn35s3: {
          activityName:
            "Elaboration of what was established on 5th of September",
          area: "Safety",
          bookPage: "38",
          date: "2022-09-08",
          description: "",
          __collections__: {},
        },
        PGGbWy2f5uSgO1QkLuq1: {
          activityName: "Serial dilutions preparation",
          area: "Safety",
          bookPage: "4",
          date: "2022-05-24",
          description: "",
          __collections__: {},
        },
        Pd7EmgVSSoPUOMUTbhbx: {
          activityName: "Repetition of protocol of 18/07/22 ",
          area: "Biosensor",
          bookPage: "74",
          date: "2022-07-19",
          description: "",
          __collections__: {},
        },
        PeuKr2at4Qh8db5V7IqS: {
          activityName: "Spatulate of treatments A, B and C ",
          area: "Safety",
          bookPage: "18",
          date: "2022-07-06",
          description: "",
          __collections__: {},
        },
        Pg0cgWx7fBRBL6d4jyF1: {
          activityName: "Nanoparticle synthesis",
          area: "Biosensor",
          bookPage: "61",
          date: "2022-09-20",
          description: "",
          __collections__: {},
        },
        PhKg1zUg0vBlvdWWBm8y: {
          activityName: "Absorbance measurement",
          area: "Safety",
          bookPage: "41",
          date: "2022-09-20",
          description: "",
          __collections__: {},
        },
        Pmx2ygaFv5NGSojXA4jK: {
          activityName: "New protocol for solid medium",
          area: "Safety",
          bookPage: "16",
          date: "2022-07-01",
          description: "",
          __collections__: {},
        },
        QJbG2dRCMMoQuDqJm0j6: {
          activityName:
            "Functionality assays with guaiacol as a substrate for laccase 15A. ",
          area: "Degradation",
          bookPage: "46",
          date: "2022-08-29",
          description: "",
          __collections__: {},
        },
        QQDtkBCfG80skbzLK7JX: {
          activityName: "Absorbance of Laccase 15A",
          area: "Degradation",
          bookPage: "34",
          date: "2022-07-25",
          description: "",
          __collections__: {},
        },
        R9fOsxLwRrBa6cCtrOiF: {
          activityName: "Absorbance readings with a protein referer",
          area: "Biosensor",
          bookPage: "70",
          date: "2022-01-27",
          description: "",
          __collections__: {},
        },
        RCGVo2Y8tP2cRpxYde9l: {
          activityName:
            "Electrophoresis and restriction map - plasmid extraction RecA1 and RecA2",
          area: "Biosensor",
          bookPage: "97",
          date: "2022-09-22",
          description: "",
          __collections__: {},
        },
        RJ8vf6n9tNIL4eIfXIoI: {
          activityName:
            "SDS-PAGES for solubility protein detection of ESR1 and LacTV strains",
          area: "Biosensor",
          bookPage: "86",
          date: "2022-09-01",
          description: "",
          __collections__: {},
        },
        RKDHsfvtMYmAGVw1RVBX: {
          activityName: "PDMS mold sealing",
          area: "Biosensor",
          bookPage: "63",
          date: "2022-10-07",
          description: "",
          __collections__: {},
        },
        ReAAjig5meR7BRoH47FI: {
          activityName: "Electrophoresis gel R1A (100V 1 hr)",
          area: "Biosensor",
          bookPage: "67",
          date: "2022-05-24",
          description: "",
          __collections__: {},
        },
        S3XCxQ5o7g9QAezsXHUU: {
          activityName: "Preparation of a NaOH solution",
          area: "Degradation",
          bookPage: "39",
          date: "2022-08-17",
          description: "",
          __collections__: {},
        },
        S6bQTcvwxqrLtkTksyF6: {
          activityName:
            "Experiment to see how much zeolite degrades the guaiacol (colorant)",
          area: "Degradation",
          bookPage: "55",
          date: "2022-10-01",
          description: "",
          __collections__: {},
        },
        SGfdMjT72KSnHAzUFNLu: {
          activityName: "Preparation of CBZ stock solutions ",
          area: "Degradation",
          bookPage: "52",
          date: "2022-09-14",
          description: "",
          __collections__: {},
        },
        SPdPMfbnAXIHy7rjwvAl: {
          activityName:
            "Inoculation of a colony in LB+CAM liquid culture for protein expression assay.",
          area: "Biosensor",
          bookPage: "65",
          date: "2022-01-19",
          description: "",
          __collections__: {},
        },
        SVJm3FjNQGNdWCL63tHI: {
          activityName:
            "Preparation of solutions for calibration curve laccase assay",
          area: "Degradation",
          bookPage: "46",
          date: "2022-08-30",
          description: "",
          __collections__: {},
        },
        ScaGGJ2kUQHeklwXycVQ: {
          activityName: "Streaking of 13I, 13M, 15A and 15E",
          area: "Degradation",
          bookPage: "2",
          date: "2022-05-24",
          description: "",
          __collections__: {},
        },
        SoKNlDXHhJUc3kKQVPd7: {
          activityName: "Inoculation ",
          area: "Biosensor",
          bookPage: "82",
          date: "2022-08-15",
          description: "",
          __collections__: {},
        },
        Sw2opWBmSW4VzTZVgIrG: {
          activityName: "Cysteine solution",
          area: "Biosensor",
          bookPage: "64",
          date: "2022-10-07",
          description: "",
          __collections__: {},
        },
        T3gActoMFcRKe3fFbcPV: {
          activityName: "Preparation of MS medium",
          area: "Degradation",
          bookPage: "13",
          date: "2022-07-04",
          description: "",
          __collections__: {},
        },
        T8VxmulyEai2c67HDP8T: {
          activityName: "Culture medium preparation",
          area: "Safety",
          bookPage: "1",
          date: "2022-05-20",
          description: "",
          __collections__: {},
        },
        TjO5j4dcAaqVIjtIMBsd: {
          activityName: "Disinfection of lettuce seeds",
          area: "Degradation",
          bookPage: "12",
          date: "2022-06-30",
          description: "",
          __collections__: {},
        },
        TwEFrgewzcw7oIIJb8WL: {
          activityName:
            "Previous steps before the ligation of Pp 22 and Nc_22 in pET-17b",
          area: "Safety",
          bookPage: "46",
          date: "2022-10-01",
          description: "",
          __collections__: {},
        },
        TyPgdf99xpfEV39QLm2A: {
          activityName: "Plasmid extraction in liquid medium",
          area: "Biosensor",
          bookPage: "75",
          date: "2022-07-21",
          description: "",
          __collections__: {},
        },
        U1zojK3XdNfYGiGpTjtN: {
          activityName: "SDS-Page was performed with Protein Buffer",
          area: "Degradation",
          bookPage: "7",
          date: "2022-06-21",
          description: "",
          __collections__: {},
        },
        UBpVfhKuUBU8ADSjjMUQ: {
          activityName:
            "AFM (Atomic force microscopy) characterization of gold nanoparticles (2)",
          area: "Biosensor",
          bookPage: "62",
          date: "2022-09-26",
          description: "",
          __collections__: {},
        },
        UJHm45hr65C1Ls9loZdW: {
          activityName:
            " DLS (Dynamic light scattering) characterization of nanoparticles (2)",
          area: "Biosensor",
          bookPage: "62",
          date: "2022-09-25",
          description: "",
          __collections__: {},
        },
        UKw0iI5yrwQDIVuBDEwW: {
          activityName:
            "Culturing of E. coli cells in liquid medium with isoeugenol 4.5 mM",
          area: "Safety",
          bookPage: "27",
          date: "2022-07-28",
          description: "",
          __collections__: {},
        },
        UTaYFByzi2JfI7Voa4eU: {
          activityName: "PCR of inteins plan 1 to 4",
          area: "Biosensor",
          bookPage: "103",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        UpvpJ0JAMJPrNV5gHQ6p: {
          activityName: "RecA intein agarose gel purification",
          area: "Biosensor",
          bookPage: "90",
          date: "2022-09-06",
          description: "",
          __collections__: {},
        },
        VHBUBkVlWrEgnAwMw5vC: {
          activityName:
            "Electrophoresis gel with the digestions carried out on September 27th",
          area: "Safety",
          bookPage: "44",
          date: "2022-09-28",
          description: "",
          __collections__: {},
        },
        VHDSEBftH83k512ccxBQ: {
          activityName:
            "Solution preparations for an assay for immobilized laccase in malachite green dye.",
          area: "Degradation",
          bookPage: "40",
          date: "2022-08-23",
          description: "",
          __collections__: {},
        },
        VRuE1KKtmzR9iy8U5vY4: {
          activityName: "Making the plan 2",
          area: "Biosensor",
          bookPage: "104",
          date: "2022-10-07",
          description: "",
          __collections__: {},
        },
        Vk0U1IkxRCjGR6EuDE4k: {
          activityName: "IR characterization of LMWC  ",
          area: "Biosensor",
          bookPage: "63",
          date: "2022-10-06",
          description: "",
          __collections__: {},
        },
        VkH7q6IORmScxZ3JC4Rf: {
          activityName: "Preparation of BPA solutions",
          area: "Degradation",
          bookPage: "13",
          date: "2022-07-04",
          description: "",
          __collections__: {},
        },
        VvKYeM3SPMPaTPtZIq50: {
          activityName: "Electrophoresis",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-03-30",
          description: "For laccases and ESR1",
          __collections__: {},
        },
        W34URX7txSi15Mk67oC8: {
          activityName: "Restriction mapping --> Digestions",
          area: "Biosensor",
          bookPage: "68",
          date: "2022-05-28",
          description: "",
          __collections__: {},
        },
        WC3QmDCU8aP67aG0hBSR: {
          activityName:
            "Liquid medium emulsification to prove isoeugenol solubility. ",
          area: "Safety",
          bookPage: "8",
          date: "2022-06-01",
          description: "",
          __collections__: {},
        },
        WP5rno2iykDJKZMZoBHP: {
          activityName: "Purification of Laccase 15A",
          area: "Degradation",
          bookPage: "33",
          date: "2022-07-21",
          description: "",
          __collections__: {},
        },
        WPf41W4or51QjS0TBkDo: {
          activityName: " Cysteine ​​coating on gold electrode",
          area: "Biosensor",
          bookPage: "64",
          date: "2022-10-10",
          description: "",
          __collections__: {},
        },
        WZVZW6uriuAxOhCPPfSq: {
          activityName: "Inoculation of laccases",
          area: "Degradation",
          bookPage: "11",
          date: "2022-06-29",
          description: "",
          __collections__: {},
        },
        X7D79g9iEddi5ADCYhVX: {
          activityName: "Electrophoresis of plasmids",
          area: "Biosensor",
          bookPage: "94",
          date: "2022-09-15",
          description: "",
          __collections__: {},
        },
        XCflSJ9LyXoNci1GxUPc: {
          activityName: "Preparation of solid medium  and E. Coli culture",
          area: "Safety",
          bookPage: "18",
          date: "2022-07-05",
          description: "",
          __collections__: {},
        },
        XGowxYyf9OE2os7p8cSO: {
          activityName:
            "SDS-PAGE for LacTV and ESR1 expression and solubility ",
          area: "Biosensor",
          bookPage: "84",
          date: "2022-08-25",
          description: "",
          __collections__: {},
        },
        XImzdklxWvvm3As175nC: {
          activityName:
            "Transformation of the ligation reactions from October 5th of DH5ɑ and BL21",
          area: "Safety",
          bookPage: "49",
          date: "2022-10-06",
          description: "",
          __collections__: {},
        },
        XbG7KQaXBOJ3GkAwfOZV: {
          activityName: "2° SDS Page of candidates ESR1 “21”, “23” and “26”",
          area: "Biosensor",
          bookPage: "66",
          date: "2022-01-21",
          description: "",
          __collections__: {},
        },
        XcW1SyD1ktCAfDLROxav: {
          activityName:
            "Germination of lettuce seeds in vitro to choose the best disinfection protocol",
          area: "Degradation",
          bookPage: "9",
          date: "2022-06-24",
          description: "",
          __collections__: {},
        },
        XtHeeuNC1Yv14NVeEe1t: {
          activityName: "Streaking of 13I, 13M, 15A and 15E",
          area: "Degradation",
          bookPage: "2",
          date: "2022-05-24",
          description: "",
          __collections__: {},
        },
        Xwp2IjGotKPBaO9YS4lk: {
          activityName:
            "SDS-PAGE running for solubility and expression ESR1+LacTV",
          area: "Biosensor",
          bookPage: "104",
          date: "2022-10-07",
          description: "",
          __collections__: {},
        },
        Y0i6qr64ApModUhodgPc: {
          activityName:
            "AFM (Atomic force microscopy) characterization of substrate",
          area: "Biosensor",
          bookPage: "62",
          date: "2022-09-26",
          description: "",
          __collections__: {},
        },
        YHarwnuPuUGOjPzstLPy: {
          activityName: "Inoculation transformed E. coli Laccase ISE",
          area: "Degradation",
          bookPage: "22",
          date: "2022-07-08",
          description: "",
          __collections__: {},
        },
        YVDmZnjBv8c6k8AhgHZa: {
          activityName: "Preparation of MS medium",
          area: "Degradation",
          bookPage: "9",
          date: "2022-06-23",
          description: "",
          __collections__: {},
        },
        YeCGIwYPUL3tKn7TSff1: {
          activityName: "MC filtering",
          area: "Degradation",
          bookPage: "30",
          date: "2022-07-15",
          description: "",
          __collections__: {},
        },
        YmyjubOJ1gKtxp02hsJe: {
          activityName: "Making the plan 1",
          area: "Biosensor",
          bookPage: "104",
          date: "2022-10-07",
          description: "",
          __collections__: {},
        },
        YyMpViI0C0vVuDwcJct0: {
          activityName: "Blunting reaction with pJET1R kit",
          area: "Biosensor",
          bookPage: "103",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        Yz3fNURuxLHLrtYWixRV: {
          activityName: "Scans of CBZ",
          area: "Degradation",
          bookPage: "37",
          date: "2022-08-11",
          description: "",
          __collections__: {},
        },
        ZFuplGN0NwbeTcuUcuIf: {
          activityName: "Seed of strains in liquid medium LB+CAM",
          area: "Degradation",
          bookPage: "11",
          date: "2022-06-28",
          description: "",
          __collections__: {},
        },
        ZKZXNaxOKKvaHlJC8hJF: {
          activityName: "Electrophoresis (ESR1, LacTV and ESR1 digestions)",
          area: "Biosensor",
          bookPage: "80",
          date: "2022-08-09",
          description: "",
          __collections__: {},
        },
        ZKnwQ6EeSVRTEyyrhF2d: {
          activityName: "Immobilization assay ",
          area: "Degradation",
          bookPage: "50",
          date: "2022-09-08",
          description: "",
          __collections__: {},
        },
        ZdtIz2gavZQDZ31TZSk1: {
          activityName:
            "Preparation of Sodium phosphates buffer at different pHs: 4.0 5.0, 6.0, 7.0 and 8.0. Concentration 0.1 M. ",
          area: "Degradation",
          bookPage: "55",
          date: "2022-10-01",
          description: "",
          __collections__: {},
        },
        ZttThpJ2BIde5pfb5stD: {
          activityName: "Solid mediums preparation",
          area: "Safety",
          bookPage: "43",
          date: "2022-09-26",
          description: "",
          __collections__: {},
        },
        a93TGMRA0TTVq1DVK0KR: {
          activityName: "ESR1 y LacTV gels (Stock and purified plasmid)",
          area: "Biosensor",
          bookPage: "93",
          date: "2022-09-13",
          description: "",
          __collections__: {},
        },
        aCRdFErOExtNdbL5PasS: {
          activityName:
            "Protocol for the emulsification of isoeugenol in mediums",
          area: "Safety",
          bookPage: "27",
          date: "2022-09-27",
          description: "",
          __collections__: {},
        },
        aKoUm7Aq4ftg0nvGyeJM: {
          activityName:
            "Electrophoresis gel with the PCR samples from October first",
          area: "Safety",
          bookPage: "47",
          date: "2022-10-04",
          description: "",
          __collections__: {},
        },
        aZO5o8xfWzIkKgGDHd76: {
          activityName:
            "Continuation of the immobilization of laccase with zeolite.",
          area: "Degradation",
          bookPage: "21",
          date: "2022-07-08",
          description: "",
          __collections__: {},
        },
        aqeyxWvIaWN9BzKaoJHt: {
          activityName: "RecA intein inoculation",
          area: "Biosensor",
          bookPage: "93",
          date: "2022-09-13",
          description: "",
          __collections__: {},
        },
        artk6Vy7GaMjGntEmABz: {
          activityName: "Preparation of B1 for BPA degradation assay",
          area: "Degradation",
          bookPage: "38",
          date: "2022-08-15",
          description: "",
          __collections__: {},
        },
        b4GjgKkeOVjExnWOIRGg: {
          activityName: "Sowing of laccases",
          area: "Degradation",
          bookPage: "11",
          date: "2022-06-29",
          description: "",
          __collections__: {},
        },
        b9E44zN6X9zMMFPcg9YM: {
          activityName:
            "UV-VIS analysis of the supernatant of the immobilized laccase in the zeolitic immidazole framework.",
          area: "Degradation",
          bookPage: "39",
          date: "2022-08-19",
          description: "",
          __collections__: {},
        },
        bHypfmLux6ajper6qndz: {
          activityName: "LB media inoculation and IPTG induction (3, 5, 8)",
          area: "Biosensor",
          bookPage: "83",
          date: "2022-08-22",
          description: "",
          __collections__: {},
        },
        bP3sZcRocU126zeCfRrb: {
          activityName: "Laccase culture medium",
          area: "Safety",
          bookPage: 0,
          date: "2022-02-18",
          description: "15A, 15E, 13M and ESRI 23",
          __collections__: {},
        },
        bSLpEz4YSYYB5O50HAW9: {
          activityName: "Obtaining ESR1 and LAC",
          area: "Biosensor",
          bookPage: "90",
          date: "2022-09-06",
          description: "",
          __collections__: {},
        },
        bUIBLH7DZdpOhFQMXKlG: {
          activityName: "Primer design",
          area: "Biosensor",
          bookPage: "69",
          date: "2022-01-25",
          description: "",
          __collections__: {},
        },
        bV1rxJ4UAW8YHkaVWnN9: {
          activityName: "Amplification PCR",
          area: "Biosensor",
          bookPage: "88",
          date: "2022-09-05",
          description: "",
          __collections__: {},
        },
        baRyJXAJbPsqkuW09J7p: {
          activityName:
            "Centricon periplasmic protein concentration SDS-PAGE from ESR1 (4) and Lac (8)",
          area: "Biosensor",
          bookPage: "92",
          date: "2022-09-12",
          description: "",
          __collections__: {},
        },
        bd2YJhOfYWn0HjHOcLh7: {
          activityName: "Preparation of MS medium ",
          area: "Degradation",
          bookPage: "8",
          date: "2022-06-21",
          description: "",
          __collections__: {},
        },
        bjI78EUQnmrHLZG4MHWO: {
          activityName: "Ex vitro seed germination",
          area: "Degradation",
          bookPage: "9",
          date: "2022-06-21",
          description: "",
          __collections__: {},
        },
        br8T98OuZuesJyD02cVy: {
          activityName: "Use of inteins. Plan 1: Free Cell System",
          area: "Biosensor",
          bookPage: "102",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        cCmQswa45mfRhBcQgzvk: {
          activityName: "Plasmid extraction",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-02-16",
          description: "",
          __collections__: {},
        },
        cDvdxa17oiJDvcxDlWex: {
          activityName: "Protocol for lettuce irrigation",
          area: "Degradation",
          bookPage: "52",
          date: "2022-09-12",
          description: "",
          __collections__: {},
        },
        cjXV6zhPLRnTpR1pwGD4: {
          activityName: "Striated of laccases",
          area: "Degradation",
          bookPage: "11",
          date: "2022-06-29",
          description: "",
          __collections__: {},
        },
        dDGpN7NamciHhxV9KY0T: {
          activityName: "SDS-PAGE gel running",
          area: "Degradation",
          bookPage: "28",
          date: "2022-07-15",
          description: "",
          __collections__: {},
        },
        dPl0BRyr6agq6gGP3PHY: {
          activityName: "Amplification PCR for ESR1 and LacTV HD22",
          area: "Biosensor",
          bookPage: "77",
          date: "2022-07-25",
          description: "",
          __collections__: {},
        },
        ddLhvoIn7SafAl2ou6BH: {
          activityName: "Absorbances purification laccase ISE Culture Medium",
          area: "Degradation",
          bookPage: "30",
          date: "2022-07-18",
          description: "",
          __collections__: {},
        },
        dggPBRR30ZRLSwPnWGj1: {
          activityName: "Gold QCM electrode topography.",
          area: "Biosensor",
          bookPage: "66",
          date: "2022-10-11",
          description: "",
          __collections__: {},
        },
        e6mSCX3rMcbbZcdWdGrg: {
          activityName:
            "Plasmid p1-17D transformation in chemically competent cells ",
          area: "Biosensor",
          bookPage: "72",
          date: "2022-07-18",
          description: "",
          __collections__: {},
        },
        eG4uVgn7twNlfp3weiMC: {
          activityName:
            "SDS-PAGE from synthetic medium with 4.5 and 7.5 mM of isoeugenol",
          area: "Safety",
          bookPage: "10",
          date: "2022-09-19",
          description: "",
          __collections__: {},
        },
        eILiValXMoPkzwOOXBEk: {
          activityName: "IntAssay",
          area: "Biosensor",
          bookPage: "95",
          date: "2022-09-20",
          description: "",
          __collections__: {},
        },
        eXRN19L22m2hxbpPmULQ: {
          activityName:
            "Repeated SDS-page experiment of solubility from lacasses from July 05, 2022.",
          area: "Degradation",
          bookPage: "15",
          date: "2022-07-06",
          description: "",
          __collections__: {},
        },
        el561GTVLoBbxYTkNZU5: {
          activityName: "Degradation assay CBZ-Lac",
          area: "Degradation",
          bookPage: "58",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        eskIHtA0gUYpfGnqwHkl: {
          activityName:
            "Chemo Transformation of BL21 with candidate plasmids “21”, “23” and “26” in LB+CAM",
          area: "Biosensor",
          bookPage: "66",
          date: "2022-01-18",
          description: "",
          __collections__: {},
        },
        f2AfU2aBALNMRVD360dZ: {
          activityName: "Serial dilutions and culturing of BL21-DE3",
          area: "Safety",
          bookPage: "25",
          date: "2022-07-21",
          description: "",
          __collections__: {},
        },
        f7qH8uYGFzS1fVohNjTL: {
          activityName: "Continuation of immobilization assay (Sep 6)",
          area: "Degradation",
          bookPage: "50",
          date: "2022-09-08",
          description: "",
          __collections__: {},
        },
        fIr770EsVWs8QlrX08k9: {
          activityName: "Evaluation of the expression of Iso-monooxygenase",
          area: "Safety",
          bookPage: "36",
          date: "2022-08-30",
          description: "",
          __collections__: {},
        },
        fhFl1hxQNLvmgiFiO4kb: {
          activityName: "Culture medium preparation",
          area: "Safety",
          bookPage: "1",
          date: "2022-05-20",
          description: "",
          __collections__: {},
        },
        fzI1yKg3VkglM3KP3H27: {
          activityName:
            "Tubes with LB liquid medium and isoeugenol and preparation of a culture of  E. Coli DH5α",
          area: "Safety",
          bookPage: "13",
          date: "2022-06-29",
          description: "",
          __collections__: {},
        },
        gJi0Wt8R7dp9cLFKIkF3: {
          activityName: "Electrophoresis 0.8% gel",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-03-17",
          description: "To check amplifications",
          __collections__: {},
        },
        gK3FsiqbNK94bgrxAu6t: {
          activityName:
            "Preparation of the solid mediums with high isoeugenol concentrations",
          area: "Safety",
          bookPage: "29",
          date: "2022-07-29",
          description: "",
          __collections__: {},
        },
        gVNvu170oP8IXZPNHtTV: {
          activityName: "Preparation of materials for next steps",
          area: "Biosensor",
          bookPage: "81",
          date: "2022-08-15",
          description: "",
          __collections__: {},
        },
        gcF2NPjGRhVw2zDuKsgE: {
          activityName: "SDS-PAGE of candidates ESR1-Soluble",
          area: "Biosensor",
          bookPage: "71",
          date: "2022-01-31",
          description: "",
          __collections__: {},
        },
        gnmVyxja8uCisUMbYahL: {
          activityName: "Ligation ESR1_HD22 and LACTV_HD22 in pJET",
          area: "Biosensor",
          bookPage: "73",
          date: "2022-07-18",
          description: "",
          __collections__: {},
        },
        gojOjZKVbP45eoJQplDI: {
          activityName: "Electrophoresis verification",
          area: "Biosensor",
          bookPage: "98",
          date: "2022-09-28",
          description: "",
          __collections__: {},
        },
        hX80jPXDNdp6xT1j6Yu5: {
          activityName: "Substrate preparation of gold nanoparticles 0.25% ",
          area: "Biosensor",
          bookPage: "62",
          date: "2022-09-28",
          description: "",
          __collections__: {},
        },
        ha3hW8S2JJnFDT5mMM6I: {
          activityName: "Degradation assay BPA-Lac",
          area: "Degradation",
          bookPage: "56",
          date: "2022-10-04",
          description: "",
          __collections__: {},
        },
        hm1xa59CLp76yYrCUcOc: {
          activityName: "Pour medium in plates and spatulation",
          area: "Safety",
          bookPage: "21",
          date: "2022-07-12",
          description: "",
          __collections__: {},
        },
        i0MkhFhg8us7oY53sjGe: {
          activityName: "SDS-PAGE repetition",
          area: "Safety",
          bookPage: "41",
          date: "2022-09-21",
          description: "",
          __collections__: {},
        },
        i5xkYWLhdCu7X3clvJ9D: {
          activityName: "Electrophoresis",
          area: "Degradation",
          bookPage: 0,
          date: "2022-03-07",
          description: "LAC15A to check if it's necessary to sequence",
          __collections__: {},
        },
        i8yPt5byYm2lIeuOCwKU: {
          activityName: "Electrophoresis gel for plasmid purification",
          area: "Biosensor",
          bookPage: "100",
          date: "2022-10-01",
          description: "",
          __collections__: {},
        },
        iQucnSUVfu51SawEK8QH: {
          activityName: "Inoculation of ESR1 and LacTV  (DH5α BL21)",
          area: "Biosensor",
          bookPage: "78",
          date: "2022-07-27",
          description: "",
          __collections__: {},
        },
        iUXDeEoAKdoFFZKOx4D4: {
          activityName: "Sterility Test of Polytron",
          area: "Safety",
          bookPage: "11",
          date: "2022-06-24",
          description: "",
          __collections__: {},
        },
        iV2H4j6xVRsqxcMORpAJ: {
          activityName: "Immobilization assay",
          area: "Degradation",
          bookPage: "48",
          date: "2022-09-06",
          description: "",
          __collections__: {},
        },
        iYDtG3gWLtOssmPMI0VY: {
          activityName: "Immobilization of laccase with zeolite.",
          area: "Degradation",
          bookPage: "19",
          date: "2022-07-07",
          description: "",
          __collections__: {},
        },
        icjqbFiyuXhnIciHqLfe: {
          activityName: "PCR and electrophoresis",
          area: "Safety",
          bookPage: 0,
          date: "2022-03-25",
          description: "To check plasmids results",
          __collections__: {},
        },
        iflSm1WfbgSYgT5QoKVh: {
          activityName: "Streaking of DH5ɑ and BL21 in EMB medium",
          area: "Safety",
          bookPage: "49",
          date: "2022-10-06",
          description: "",
          __collections__: {},
        },
        igdvCmdUAWlj4aFC0NsT: {
          activityName: "Calibration curve of BSA with BPA",
          area: "Degradation",
          bookPage: "15",
          date: "2022-06-05",
          description: "",
          __collections__: {},
        },
        iiLB2Hl2RfmRgUS35ejG: {
          activityName: "Restriction map ESR1 and LacTV HD22",
          area: "Biosensor",
          bookPage: "76",
          date: "2022-07-25",
          description: "",
          __collections__: {},
        },
        ijC7JKpyW1bO1SBG2IT4: {
          activityName: "Electrophoresis gel to analyze digestions and PCR",
          area: "Biosensor",
          bookPage: "78",
          date: "2022-07-26",
          description: "",
          __collections__: {},
        },
        ikJZAIhwYTLBXlihbDh9: {
          activityName: "PCR",
          area: "Degradation",
          bookPage: 0,
          date: "2022-03-16",
          description: "To check amplification",
          __collections__: {},
        },
        j4o6BTJeYIv1oV0RbQZp: {
          activityName: "Electrophoresis",
          area: "Degradation",
          bookPage: 0,
          date: "2022-03-10",
          description: "To check PCR",
          __collections__: {},
        },
        jHslLZDkxTIjoIkSpQOH: {
          activityName: "SDS-page experiment of the immobilization washes. ",
          area: "Degradation",
          bookPage: "25",
          date: "2022-07-13",
          description: "",
          __collections__: {},
        },
        jO6YHWDFg7JMFmalMvy0: {
          activityName:
            "Absorbance reading of immobilization supernatant performed on August 26, 2022.",
          area: "Degradation",
          bookPage: "44",
          date: "2022-08-29",
          description: "",
          __collections__: {},
        },
        jSxNuNiqDpHEN59KtUUD: {
          activityName: "Preparation of LB medium",
          area: "Safety",
          bookPage: 0,
          date: "2022-03-22",
          description: "",
          __collections__: {},
        },
        jhS5By2cNZXAeA7JIQaL: {
          activityName: "Vial treatment of Isoeugenol monooxygenases sequences",
          area: "Safety",
          bookPage: "23",
          date: "2022-07-20",
          description: "",
          __collections__: {},
        },
        kRLBNN7BNRhPyvr7E7TQ: {
          activityName: "IR characterization of gold nanoparticles 0.25%",
          area: "Degradation",
          bookPage: "63",
          date: "2022-10-06",
          description: "",
          __collections__: {},
        },
        kUB3zFgyZByEipEJeyyD: {
          activityName: "Results of cultured cells of the backups",
          area: "Safety",
          bookPage: "25",
          date: "2022-07-25",
          description: "",
          __collections__: {},
        },
        ka1zCukN5X1ks9yS9x9D: {
          activityName: "Quantitative experiment with guaiacol (control).",
          area: "Degradation",
          bookPage: "42",
          date: "2022-08-24",
          description: "",
          __collections__: {},
        },
        kguzqbxrYlYhhJnqPd7X: {
          activityName: "Purification of electrophoresis gel for ligation",
          area: "Safety",
          bookPage: "47",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        kvppVhIg7r3E9OEQ62ae: {
          activityName: "PCR - Amplification",
          area: "Safety",
          bookPage: "30",
          date: "2022-08-10",
          description: "",
          __collections__: {},
        },
        lIxtJxMDcG22lnKBNJmg: {
          activityName: "Laccase expression and solubility assay inoculation",
          area: "Degradation",
          bookPage: "2",
          date: "2022-05-25",
          description: "",
          __collections__: {},
        },
        lSHMVJURotbgbn5F3v7F: {
          activityName: "Absorbance measurement with the experimentals above",
          area: "Degradation",
          bookPage: "13",
          date: "2022-07-05",
          description: "",
          __collections__: {},
        },
        lVG7h4pPCiNrRvy0gZrc: {
          activityName: "IPTG induction",
          area: "Degradation",
          bookPage: "11",
          date: "2022-06-29",
          description: "",
          __collections__: {},
        },
        lX646KnSmvuIgsvue033: {
          activityName: "UV-Vis assay of immobilization",
          area: "Degradation",
          bookPage: "52",
          date: "2022-09-19",
          description: "",
          __collections__: {},
        },
        lpXrwPRgCDHqACc4UxKp: {
          activityName: "Plasmid extraction",
          area: "Degradation",
          bookPage: 0,
          date: "2022-03-14",
          description: "Laccases and ESR1",
          __collections__: {},
        },
        mTGeeaBPvPNM4NZCW4vM: {
          activityName: "Preparation and plating LB+CAM",
          area: "Degradation",
          bookPage: "22",
          date: "2022-07-08",
          description: "",
          __collections__: {},
        },
        mVymvE3wvsI1S5J4TwhP: {
          activityName: "ESRI4 and Lac8 digestions",
          area: "Biosensor",
          bookPage: "98",
          date: "2022-09-26",
          description: "",
          __collections__: {},
        },
        mot9LIP70FKJDIuWjokZ: {
          activityName: "Plasmid verification electrophoresis gel ESR1.",
          area: "Biosensor",
          bookPage: "69",
          date: "2022-05-30",
          description: "",
          __collections__: {},
        },
        nHS2pLh2CtpXtLE0IsZx: {
          activityName: "Laccase production (1L)",
          area: "Degradation",
          bookPage: "22",
          date: "2022-07-08",
          description: "",
          __collections__: {},
        },
        nhI5qkOsIuCQZcJo3OED: {
          activityName: "Preparation of 300 mL phosphates buffer 0.1 M pH 6.0",
          area: "Degradation",
          bookPage: "56",
          date: "2022-10-03",
          description: "",
          __collections__: {},
        },
        nwkVF3uJwpyovvZAbgkY: {
          activityName: "SDS-PAGE gel preparation",
          area: "Degradation",
          bookPage: "34",
          date: "2022-07-22",
          description: "",
          __collections__: {},
        },
        oBpB2bFFsquajFno0EHm: {
          activityName:
            "Absorbances purification laccase ISE IMAC soluble protein",
          area: "Degradation",
          bookPage: "27",
          date: "2022-07-14",
          description: "",
          __collections__: {},
        },
        pTgNq4wJrdwFHCJ9z8s1: {
          activityName: "Inoculation of laccase and ESR1",
          area: "Safety",
          bookPage: 0,
          date: "2022-03-23",
          description: "With LB medium and CAM",
          __collections__: {},
        },
        pfqHQXVpph7NRtaSwByp: {
          activityName:
            "Ligation of gBlock on pJET 1.2 vector and synthesized ESR1 construct and Laccase construct.  ",
          area: "Biosensor",
          bookPage: "1",
          date: "2022-07-18",
          description:
            "ESR1 and LacTV constructs were ligated into pJET1.2/blunt and transformed into DH5-alpha strains.",
          __collections__: {},
        },
        pirmU8MjyamabezXCFIQ: {
          activityName:
            "Results of the spatulated plates 18 hours later (10 am)",
          area: "Safety",
          bookPage: "22",
          date: "2022-07-13",
          description: "",
          __collections__: {},
        },
        pjI6V5uJjF3D3eqtcCr7: {
          activityName: "Carbamazepine concentration curve",
          area: "Degradation",
          bookPage: "39",
          date: "2022-08-19",
          description: "",
          __collections__: {},
        },
        qJDZtHL1IZM2l0isbw5k: {
          activityName:
            "SEM (Scanning Electron Microscope) characterization of quasi-hydrogel gold nanoparticles",
          area: "Safety",
          bookPage: "61",
          date: "2022-09-22",
          description: "",
          __collections__: {},
        },
        qteUIRHtMLK0nc1fvzHN: {
          activityName: "Laccase expression and solubility assay (second time)",
          area: "Degradation",
          bookPage: "5",
          date: "2022-06-16",
          description: "",
          __collections__: {},
        },
        r6myIsDKsP0NcRPpJLAq: {
          activityName: "Use of inteins. Plan 2: HMS174 with pJET 1.2 lysed",
          area: "Biosensor",
          bookPage: "102",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        r7EIosavJ6jft0hxXKFT: {
          activityName: "Laemmli 5X buffer preparation",
          area: "Degradation",
          bookPage: "5",
          date: "2022-06-16",
          description: "",
          __collections__: {},
        },
        rGY5X662d2FTJjMYzJAX: {
          activityName:
            "Physicochemical water analysis (pH, conductivity and ATR).",
          area: "Degradation",
          bookPage: "16",
          date: "2022-07-07",
          description: "",
          __collections__: {},
        },
        rhnHABTDfXcvRuT0NKcP: {
          activityName:
            "Preparation of solid medium for the emulsification of isoeugenol",
          area: "Safety",
          bookPage: "10",
          date: "2022-06-22",
          description: "",
          __collections__: {},
        },
        rqmDOxdkOQug9wAZLKuJ: {
          activityName: "DNA Sequenciation",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-02-14",
          description: "To check the correct nucleotide clonation",
          __collections__: {},
        },
        sDUcIymehJOzPRrUIV4y: {
          activityName: "SDS Page of candidates ESR1 “21”, “23” and “26”",
          area: "Biosensor",
          bookPage: "65",
          date: "2022-01-20",
          description: "",
          __collections__: {},
        },
        siOCeJH8tF5X898pQqNz: {
          activityName: "Electrophoresis verification",
          area: "Biosensor",
          bookPage: "99",
          date: "2022-09-29",
          description: "",
          __collections__: {},
        },
        snd64FJFG29icNOiuYNz: {
          activityName: "Preparation of citrate buffer pH 5.7",
          area: "Degradation",
          bookPage: "31",
          date: "2022-07-19",
          description: "",
          __collections__: {},
        },
        soTkhOmfwhypGVZRblx1: {
          activityName: " Mold adapting",
          area: "Biosensor",
          bookPage: "64",
          date: "2022-10-10",
          description: "",
          __collections__: {},
        },
        t36yFT48X51b2G1chhvW: {
          activityName: "Protein purification",
          area: "Biosensor",
          bookPage: "82",
          date: "2022-08-17",
          description: "",
          __collections__: {},
        },
        tFGGXH5yG7PGikD4kcgO: {
          activityName: "Solid medium preparation",
          area: "Safety",
          bookPage: "8",
          date: "2022-06-01",
          description: "",
          __collections__: {},
        },
        tIJMslLY2IgtNNhkcyDz: {
          activityName: "Preparation of the samples for the SDS-PAGE",
          area: "Safety",
          bookPage: "36",
          date: "2022-08-31",
          description: "",
          __collections__: {},
        },
        tNk0R4D1sOMoSuuNOShZ: {
          activityName: "Purification of Laccase 15A",
          area: "Degradation",
          bookPage: "34",
          date: "2022-07-22",
          description: "",
          __collections__: {},
        },
        tQrV3siUrVQgoZ8v51mo: {
          activityName:
            "Sample preparation and running SDS-PAGE test IMAC Lac ISE",
          area: "Degradation",
          bookPage: "23",
          date: "2022-07-11",
          description: "",
          __collections__: {},
        },
        tyamWZESLBrxUpd5v6dk: {
          activityName: "Preparation of citrate buffer 100 mM pH 5.7",
          area: "Degradation",
          bookPage: "48",
          date: "2022-09-06",
          description: "",
          __collections__: {},
        },
        uLdLEt08n0KvUHwv5r3q: {
          activityName: "Medium preparation for its analysis in Zeta",
          area: "Safety",
          bookPage: "23",
          date: "2022-08-31",
          description: "",
          __collections__: {},
        },
        uO74Hpm2LWicvoKaV63M: {
          activityName:
            "Functionality test of Laccase with colorant (malachite green)",
          area: "Degradation",
          bookPage: "36",
          date: "2022-08-09",
          description: "",
          __collections__: {},
        },
        uPLnZiwUbhtouOi29QkH: {
          activityName: "Plasmid PCR",
          area: "Biosensor",
          bookPage: "80",
          date: "2022-08-08",
          description: "",
          __collections__: {},
        },
        uV5BqWFQBqzfnzqzAmYe: {
          activityName: "PCR Amplification",
          area: "Degradation",
          bookPage: 0,
          date: "2022-03-08",
          description: "LAC15A",
          __collections__: {},
        },
        uhYReCn53KV2zs0aw1O4: {
          activityName:
            "Overlapping PCR program for RecA intein fragments ligation",
          area: "Biosensor",
          bookPage: "87",
          date: "2022-09-05",
          description: "",
          __collections__: {},
        },
        uv060GkaXInJsAUiZqQ7: {
          activityName: "Strain inoculation and dilutions ",
          area: "Degradation",
          bookPage: "86",
          date: "2022-08-31",
          description: "",
          __collections__: {},
        },
        uzAJgMpa5wUcoeoFebbS: {
          activityName: "Electrophoresis",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-02-24",
          description: "To check digestions",
          __collections__: {},
        },
        vBB691PBj1SUeQpHcyB2: {
          activityName: "Time vs absorbance",
          area: "Safety",
          bookPage: "5",
          date: "2022-05-26",
          description: "",
          __collections__: {},
        },
        vYDUbUuNwmKS5Fe5whAW: {
          activityName: "Treatment A – chosen",
          area: "Safety",
          bookPage: "19",
          date: "2022-07-07",
          description: "",
          __collections__: {},
        },
        vaPtM7pvuANP1kKrbofC: {
          activityName: "Malachite green absorbances",
          area: "Degradation",
          bookPage: "48",
          date: "2022-09-05",
          description: "",
          __collections__: {},
        },
        wFbIk0r9Jp1qrS0v38bj: {
          activityName:
            "Repetition of the evaluation of the proteins expression",
          area: "Safety",
          bookPage: "37",
          date: "2022-09-05",
          description: "",
          __collections__: {},
        },
        wLtoY5LReErWAjW4zpyf: {
          activityName: "Preparation of Carbamazepine solutions",
          area: "Degradation",
          bookPage: "36",
          date: "2022-07-25",
          description: "",
          __collections__: {},
        },
        wWlp0mZtijEO8pT2ADEO: {
          activityName: "Lysis",
          area: "Degradation",
          bookPage: "24",
          date: "2022-07-12",
          description: "",
          __collections__: {},
        },
        wX6rkix5ohLIcjLQo2hw: {
          activityName: "Preview of BPA degradation with laccase",
          area: "Degradation",
          bookPage: "32",
          date: "2022-07-20",
          description: "",
          __collections__: {},
        },
        wbvaojrll9d0yVuHI0f6: {
          activityName: "Calibration curve with BSA+BPA+Citrate buffer",
          area: "Degradation",
          bookPage: "13",
          date: "2022-07-04",
          description: "",
          __collections__: {},
        },
        we7LgVyDRj6OiaXZxsZ5: {
          activityName: "Absorbance of degradation assay CBZ-Lac",
          area: "Degradation",
          bookPage: "59",
          date: "2022-10-05",
          description: "",
          __collections__: {},
        },
        xFmGBXGNNIMCr649daZK: {
          activityName: "Electrophoresis",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-03-01",
          description: "To check PCR amplification",
          __collections__: {},
        },
        xvQjmbKCvzm4bOyGgV7V: {
          activityName: "Counting of colonies of BL21",
          area: "Safety",
          bookPage: "45",
          date: "2022-10-01",
          description: "",
          __collections__: {},
        },
        xzWPU9eqxhhqM7QzzWjz: {
          activityName: "Abstract of assay",
          area: "Degradation",
          bookPage: "57",
          date: "2022-10-04",
          description: "",
          __collections__: {},
        },
        y9R7PHDuayphEFNVvTD8: {
          activityName: "Antibiogram",
          area: "Safety",
          bookPage: "49",
          date: "2022-10-07",
          description: "",
          __collections__: {},
        },
        yHjqqh89LCHaxV64rOe0: {
          activityName: "PCR",
          area: "Biosensor",
          bookPage: 0,
          date: "2022-02-28",
          description: "LAC15A and ESR1",
          __collections__: {},
        },
        ybsM5bVMhSyWkFjXLH1t: {
          activityName: "Laccase calibration curve",
          area: "Degradation",
          bookPage: "46",
          date: "2022-08-31",
          description: "",
          __collections__: {},
        },
        ydsCFFzzAiZsuP3kWeCj: {
          activityName: "SDS-PAGE with protein buffer",
          area: "Degradation",
          bookPage: "8",
          date: "2022-06-21",
          description: "",
          __collections__: {},
        },
        ygVWf06ngSqMeieelnEG: {
          activityName:
            "Laccase expression and solubility assay inoculation (second time)",
          area: "Degradation",
          bookPage: "5",
          date: "2022-06-15",
          description: "",
          __collections__: {},
        },
        youn5GBhdEWh4Yf32eKs: {
          activityName: "Protein precipitate in culture medium 130 and 147",
          area: "Degradation",
          bookPage: "30",
          date: "2022-07-15",
          description: "",
          __collections__: {},
        },
        z37fjLdMGJ3qujucxfuk: {
          activityName:
            "Laccase expression and solubility assay SDS-PAGE analysis",
          area: "Degradation",
          bookPage: "3",
          date: "2022-05-31",
          description: "",
          __collections__: {},
        },
        zFQ5GIhbkdiS99e72KWJ: {
          activityName: "Preparation of phosphates buffer",
          area: "Degradation",
          bookPage: "15",
          date: "2022-07-05",
          description: "",
          __collections__: {},
        },
      },
    },
  ];
}
